import { render, staticRenderFns } from "./Peering.vue?vue&type=template&id=952a770e&scoped=true"
import script from "./Peering.vue?vue&type=script&lang=js"
export * from "./Peering.vue?vue&type=script&lang=js"
import style0 from "./Peering.vue?vue&type=style&index=0&id=952a770e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "952a770e",
  null
  
)

export default component.exports